"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var ReleaseItemPromos =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleaseItemPromos, _DomainObject_1$Domai);

  function ReleaseItemPromos(promotions) {
    var _this;

    _classCallCheck(this, ReleaseItemPromos);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemPromos).call(this));
    _this.promotions = promotions;
    return _this;
  }

  return ReleaseItemPromos;
}(DomainObject_1.DomainObject);

exports.ReleaseItemPromos = ReleaseItemPromos;